import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api_url } from '../../constant/constant';
import { useNavigate } from 'react-router-dom';
const Callback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        if(code && !window._exchangeCalled) {
          window._exchangeCalled = true;
          handleExchange(code);
        }
        console.log("Extracted Token:", code); 
    }, [location]);
      const handleExchange = async (code) => {
        const raw = JSON.stringify({
          "code": code
        });
        try {
          const response = await fetch(api_url + "/auth/microsoft/exchange", {
            mode: "cors",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body:raw
          });
    
          if (!response.ok) {
            const errorData = await response.json();
            console.log("errorData",errorData);
            alert(errorData?.error);
            window.location = "/login";            
          }
    
          const data = await response.json();   
          console.log("data response:",data);
          if(data?.token){
            localStorage.setItem("userToken", data?.token);
            handleSubmit(data?.token);
          }
        } catch (err) {
          console.error(err);
        }
      };
    const handleSubmit = async (token) => {
        try {
          const response = await fetch(api_url + "/user/microsoft/check-cases", {
            mode: "cors",
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
    
          if (!response.ok) {
            const errorData = await response.json();
            console.log("errorData",errorData);
            if (errorData?.terms) {
              localStorage.setItem("userToken",errorData?.token);
              navigate('/TermsCondition', { state: { terms: errorData.terms } }); 
              return;
            }
            if (errorData.status=='requires_action'&&errorData.code=="requires_gender_selection") {
              console.log("aa",errorData);
              // Redirect to gender selection page or prompt
              localStorage.user_id = errorData?.user.user_id;
              window.location = "/UpdategenderNormal";
              return;
            }
          }
    
          const data = await response.json();
          console.log("data response:",data.user);
          if (data?.assessment_required == true) {
            localStorage.setItem("questions", JSON.stringify(data.questions));
            localStorage.setItem("userData", JSON.stringify({role_id:5})); 
            localStorage.setItem("userToken",data?.token);
            window.location = "/Assessment";
            return;
          }
          if (data?.status == "success") {
            // localStorage.setItem("userData", JSON.stringify({role_id:5})); 
            localStorage.setItem("userData", JSON.stringify(data.user));
            window.location = "/user/dashboard";
          }

        } catch (err) {
          console.error(err.message);
        }
      };
    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
    );
};

export default Callback;
